
import React, { useRef, useCallback, useMemo } from 'react';
import { WebCache } from '../../services/WebCache';
import { t } from 'i18next';
import { attachWalletLogo, attachIssuerLogo, buildPrintableSrcDoc } from '../../utils/printable';

export type CouponIframeProps = {
  /**
   * HTML del cupón
   */
  couponHtml: string;

  /**
   * Etiqueta del botón de imprimir/descargar.
   * Default: 'Descargar cupón'
   */
  buttonLabel?: string;

  /**
   * Alto del iframe 
   * Default: '90vh'
   */
  height?: string;

  /**
   * Estilos adicionales para el iframe.
   */
  style?: React.CSSProperties;

};

const DEFAULT_SANDBOX =
  'allow-same-origin allow-scripts allow-popups allow-forms allow-modals';

export const CouponIframe: React.FC<CouponIframeProps> = ({
  couponHtml,
  buttonLabel = 'Descargar cupón',
  height = '90vh',
  style={ width: '100%', height: '90%', border: 'none', overflow: "none" }
}) => {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const buildTicket = (ticket: string) => {
        let value= ticket;
        // if(!WebCache.isUserUYU()){ //si es argentina 
        value= attachWalletLogo(value, t);
        // }
        value= attachIssuerLogo(value, t);
        return buildPrintableSrcDoc(value);
    }

  // HTML final que se inyecta en el iframe: si hay transformador, lo aplicamos.
  const Html = useMemo(() => {
    if (!couponHtml || typeof couponHtml !== 'string' || couponHtml.trim() === '') {
        return '';
    } 
    return buildTicket(couponHtml);
  }, [couponHtml]);

  const printIframe = useCallback(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const win = iframe.contentWindow;
    if (!win) return;

    try {

      // Intento estándar: imprimir directamente el contenido del iframe
      win.focus();
      win.print();
      return;
    } catch (e) {
      console.log(e)
    }

    // Fallback: abrir nueva ventana con el HTML final si lo tenemos
    if (Html) {
      const w = window.open('', '_blank');
      if (w) {
        w.document.open();
        w.document.write(Html);
        w.document.close();
        w.focus();
        w.print();
      }
    }
  }, [Html]);

  const iframeStyle: React.CSSProperties = {
    width: '100%',
    height,
    border: 'none',
    ...style,
  };

  return (
    <>
      {Html && (
        <iframe
          ref={iframeRef}
          title="coupon"
          srcDoc={Html}
          sandbox={DEFAULT_SANDBOX}
          style={iframeStyle}
        />
       )} 

      <div className="d-flex justify-content-center align-items-center mt-3">
          <button className="btn btn-primary" onClick={printIframe}>
            {buttonLabel}
          </button>
      </div>
    </>
  );
};

export default CouponIframe;